const settings = {
  brandSite: true,
  channels: [
    {
      channel: 'Linie Aquavit EN',
      locale: 'en-US',
      languageCode: 'en',
      slugs: {
        ContentfulArticlePage: 'articles',
      },
    },
    {
      channel: 'Linie Aquavit DK',
      locale: 'da-DK',
      languageCode: 'da',
      slugs: {
        ContentfulArticlePage: 'artikler',
      },
    },
    {
      channel: 'Linie Aquavit DE',
      locale: 'de-DE',
      languageCode: 'de',
      slugs: {
        ContentfulArticlePage: 'Artikel',
      },
    },
  ],
  localization: {
    default: 'en-US',
    defaultLanguageCode: 'en',
  },
};

export default settings;
